<template>
  <nav class="sub-sub-menu-nav">
    <ul class="sub-sub-menu">
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link back-link"
          :to="{ name: 'SubgroupAdminSubgroups' }"
          @click.prevent="gotoRoute({ name: 'SubgroupAdminSubgroups' })">
          <span
            class="text-sm sm:text-base font-bold text-primary m-0 my-2 sm:my-0 px-4"
            v-if="isObject(subgroup) && subgroup.title">
            <IconService class="sub-sub-menu-item-icon text-primary" />{{ subgroup.title }}
          </span>
        </router-link>
      </li>
      <li
        class="sub-sub-menu-item"
        v-if="isObject(group) && group.id && isObject(subgroup) && subgroup.id">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{
            name: 'SubgroupAdminVirtualGroups',
            params: { groupId: group.id, subgroupId: subgroup.id }
          }"
          @click.prevent="
            gotoRoute({
              name: 'SubgroupAdminVirtualGroups',
              params: { groupId: group.id, subgroupId: subgroup.id }
            })
          "
          ><IconCourse class="sub-sub-menu-item-icon text-green-700" />Upcoming {{ $t("Virtual Groups") }}</router-link
        >
      </li>
      <li
        class="sub-sub-menu-item"
        v-if="isObject(group) && group.id && isObject(subgroup) && subgroup.id">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{
            name: 'SubgroupAdminHistoricVirtualGroups',
            params: { groupId: group.id, subgroupId: subgroup.id }
          }"
          @click.prevent="
            gotoRoute({
              name: 'SubgroupAdminHistoricVirtualGroups',
              params: { groupId: group.id, subgroupId: subgroup.id }
            })
          "
          ><IconCourse class="sub-sub-menu-item-icon text-gray-400" />Past {{ $t("Virtual Groups") }}</router-link
        >
      </li>
      <li
        class="sub-sub-menu-item"
        v-if="isObject(subgroup) && subgroup.group_id && subgroup.id">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{
            name: 'SubgroupAdminSubgroupMembers',
            params: { groupId: subgroup.group_id, subgroupId: subgroup.id }
          }"
          @click.prevent="
            gotoRoute({
              name: 'SubgroupAdminSubgroupMembers',
              params: { groupId: subgroup.group_id, subgroupId: subgroup.id }
            })
          "
          ><IconUserGroup class="sub-sub-menu-item-icon" />Members</router-link
        >
      </li>
      <li
        class="sub-sub-menu-item"
        v-if="canViewLicencesPage">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{
            name: 'SubgroupAdminSubgroupLicences',
            params: { groupId: subgroup.group_id, subgroupId: subgroup.id }
          }"
          @click.prevent="
            gotoRoute({
              name: 'SubgroupAdminSubgroupLicences',
              params: { groupId: subgroup.group_id, subgroupId: subgroup.id }
            })
          "
          ><IconLicence class="sub-sub-menu-item-icon" />Licences</router-link
        >
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          v-if="isObject(group) && group.id && isObject(subgroup) && subgroup.id"
          class="sub-sub-menu-item-link"
          :to="{ name: 'SubgroupAdminSettings', params: { groupId: group.id, subgroupId: subgroup.id } }"
          @click.prevent="
            gotoRoute({
              name: 'SubgroupAdminSettings',
              params: { groupId: group.id, subgroupId: subgroup.id }
            })
          "
          ><IconCog class="sub-sub-menu-item-icon" />Settings</router-link
        >
      </li>
    </ul>
    <ul
      class="sub-sub-menu"
      v-if="$store.state.user.subgroups_managed_count > 1">
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link back-link"
          :to="{ name: 'SubgroupAdminSubgroups' }"
          @click.prevent="gotoRoute({ name: 'SubgroupAdminSubgroups' })"
          ><IconService class="sub-sub-menu-item-icon" />All {{ $t("subgroups") }}</router-link
        >
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "SubgroupAdminGroupingSubSubMenu",
  computed: {
    group() {
      return this.$store.state.admin.currentGroup;
    },
    subgroup() {
      return this.$store.state.admin.currentSubgroup;
    },
    canViewLicencesPage() {
      if (this.hasSuperAdmin || this.hasGroupAdmin) {
        return true;
      }

      if (
        this.hasSubgroupAdmin &&
        this.subgroup &&
        this.subgroup.group_id &&
        this.subgroup.id &&
        this.subgroupAdminLevel(this.subgroup.id) !== "LOW"
      ) {
        return true;
      }

      return false;
    }
  },
  methods: {
    isObject(obj) {
      return !!(typeof obj === "object" && obj !== null && obj !== undefined);
    },
    gotoRoute(route) {
      this.$router.push(route);
      this.$store.commit("closeMobileMenu");
    }
  }
};
</script>
